import MaterialTable from '@material-ui/core/Table';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSortBy, useTable } from 'react-table';
import Body from './body/Body';
import Head from './head/Head';
import { TableHeaderExact } from '../models/tableHeader';
import { TableRowActionExact } from '../models/tableRowAction';
import { Loader } from '../../common/components/loaders';
import useStyles from './Table.styles';

export const defaultTake = 10;
export const defaultTakeForClients = 30;
export const halfPageTableHeight = 300;
export const fullPageTableHeight = 548;

export const sizeEnum = {
  small: 'small',
  medium: 'medium',
};

const Table = ({ columns, data, onRowClick, rowActions, height, onPageChange, size, headerStyle, selectedRowEntityId }) => {
  const classes = useStyles();

  const { headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);

  const handlePageChange = useCallback(() => {
    if (onPageChange) {
      onPageChange({ take: defaultTake, skip: data.length });
    }
  }, [data, onPageChange]);

  const hasMoreData = useMemo(() => (data.length > 0 && onPageChange ? data.length % defaultTake === 0 : false), [onPageChange, data]);

  return (
    <>
      <InfiniteScroll dataLength={data.length} height={height} next={handlePageChange} loader={<Loader className={classes.loader} />} hasMore={hasMoreData}>
        <MaterialTable size={size} stickyHeader>
          <Head headerGroups={headerGroups} hasActions={rowActions && !!rowActions.length} headerStyle={headerStyle} />
          <Body rows={rows} prepareRow={prepareRow} onRowClick={onRowClick} rowActions={rowActions} selectedRowEntityId={selectedRowEntityId} />
        </MaterialTable>
      </InfiniteScroll>
    </>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(TableHeaderExact).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  headerStyle: PropTypes.shape(),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onPageChange: PropTypes.func,
  onRowClick: PropTypes.func,
  rowActions: PropTypes.arrayOf(TableRowActionExact),
  selectedRowEntityId: PropTypes.number,
  size: PropTypes.oneOf(Object.values(sizeEnum)),
};

Table.defaultProps = {
  headerStyle: undefined,
  height: undefined,
  onPageChange: undefined,
  onRowClick: undefined,
  rowActions: [],
  selectedRowEntityId: undefined,
  size: sizeEnum.medium,
};

export default Table;
